import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { withRouter } from 'react-router-dom';

@inject('CommonStore')
@observer
class ProtectedRoute extends Component {
  render() {
    if (!this.props.AuthStore.isLoggedIn) {
      const { pathname, search } = this.props.location;
      const location = {
        pathname: '/login',
        state: { from: { pathname, search } }
      };
      this.props.history.push(location);
      return null;
    } else {
      const PropComponent = this.props.component;
      return (
        <PropComponent
          reportHandler={this.reportHandler}
          {...this.state}
          {...this.props}
        />
      );
    }
  }
}

export default withRouter(ProtectedRoute);
